import { BudgetModel } from 'src/types/budget.model';
import { BudgetSummaryStatus } from 'src/types/budget-summary-status.enum';
import { BUDGET_OVERALL_ID } from 'src/services/budget.service';

export function getBudgetForCategory(budgets: BudgetModel[], categoryId: string): BudgetModel {
    return budgets?.find((budget) => budget?.groupId === categoryId);
}

export function getTrackerStatus(actualAmount: number, budgetAmount: number): BudgetSummaryStatus {
    const progress: number = getProgressPercent(actualAmount, budgetAmount);
    let status = BudgetSummaryStatus.ON_TRACK;
    if (progress > 75) {
        status = BudgetSummaryStatus.AT_RISK;
    }
    if (budgetAmount - actualAmount < 0) {
        status = BudgetSummaryStatus.OVER;
    }
    return status;
}

export function getProgressPercent(actualAmount: number, budgetAmount: number): number {
    return budgetAmount ? Math.round(Math.min((Math.max(0, actualAmount) / budgetAmount) * 100, 100)) : 0;
}

export function getOverBudgetPercent(actualAmount: number, budgetAmount: number): number {
    const overAmount: number = actualAmount - budgetAmount;
    return overAmount > 0 ? Math.round(Math.min((overAmount / (budgetAmount + overAmount)) * 100, 100)) : 0;
}

export function getCategoryBudgets(budgets: BudgetModel[]): BudgetModel[] {
    return budgets?.filter((budget: BudgetModel) => budget.groupId !== BUDGET_OVERALL_ID);
}
